import { createContext } from 'react';

const PlatformSettingsContext = createContext(undefined);

export default PlatformSettingsContext;
